import { intl } from '../../../../../../../../../i18n'
import { ProcessTreeSelect } from '../../../../ProjectPlanSelect/ProcessTreeSelect'
import { usePageConfigHandlers } from '../hooks/usePageConfigHandlers'
import {
  ConfigContainer,
  SectionContent,
  PageTitleSection,
  FormSection,
  FormLabel,
  PageTitleInput,
} from '../styles'
import { VersionReportVersionPageFormModel } from '../../../model/VersionReportVersionPageFormModel'

type ConfigFormProps = {
  page: VersionReportVersionPageFormModel
  snapshotUuid: string
  onUpdate: (
    pageNumber: number,
    updater: (
      prev: VersionReportVersionPageFormModel
    ) => VersionReportVersionPageFormModel
  ) => void
}

export const ProgressReportByProcessConfigForm = ({
  page,
  snapshotUuid,
  onUpdate,
}: ConfigFormProps) => {
  const { handlePageTitleChange, handleTableRowsChange } =
    usePageConfigHandlers(page, onUpdate)

  return (
    <ConfigContainer>
      <PageTitleSection>
        <PageTitleInput
          label={intl.formatMessage({
            id: 'versionReport.pageConfig.pageTitle',
          })}
          value={page.pageTitle}
          onChange={handlePageTitleChange}
          placeholder={intl.formatMessage({
            id: 'versionReport.pageConfig.pageTitle.placeholder',
          })}
          variant="outlined"
          required={true}
        />
      </PageTitleSection>
      <SectionContent>
        <FormSection>
          <FormLabel>集計対象の工程を選択してください</FormLabel>
          <ProcessTreeSelect
            key={page.pageNumber}
            snapshotUuid={snapshotUuid}
            value={page.config.tableRows}
            onChange={handleTableRowsChange}
            rows={page.rows}
          />
        </FormSection>
      </SectionContent>
    </ConfigContainer>
  )
}
